import '../modules/select';

// Toggle views
$('.btn-view').on('click', function () {
  location.hash = $(this).data('href');
  setView();
});


function setView() {
  $('.btn-view').removeClass('active');

  if (location.hash === '#grid') {
    $('.js-view-grid').addClass('active');
    $('.js-view-content').addClass('page-brand__alphabet--grid');
  } else {
    $('.js-view-list').addClass('active');
    $('.js-view-content').removeClass('page-brand__alphabet--grid');
  }
}

$(document).ready(function () {
  setView();
});